/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultOrder } from '../../models/api-response-paged-result-order';
import { PagedRequestSearchOrders } from '../../models/paged-request-search-orders';

export interface SearchOrders$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestSearchOrders
}

export function searchOrders(http: HttpClient, rootUrl: string, params: SearchOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultOrder>> {
  const rb = new RequestBuilder(rootUrl, searchOrders.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultOrder>;
    })
  );
}

searchOrders.PATH = '/v1/api/orders/search';
